import { useState } from "react";
import "./PartnerSelectModal.css";

const PartnerSelectModal = ({
  title,
  items,
  selected,
  onSelect,
  show,
  onClose
}) => {
  const [search, setSearch] = useState("");

  if (!show) return null;

  // ✅ Normalize items (support string OR object)
  const normalizedItems = items.map(item =>
    typeof item === "string"
      ? { label: item, value: item }
      : item
  );

  // ✅ Search filter
  const filteredItems = normalizedItems.filter(item =>
    item.label.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>

        <h3>{title}</h3>

        <input
          type="text"
          placeholder={`Search ${title}...`}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="search-box"
        />

        <div className="modal-list">

          {/* ✅ ITEMS */}
          {filteredItems.map(item => (
            <button
              key={item.value}
              className={selected === item.value ? "active" : ""}
              onClick={() => {
                onSelect(item.value);
                onClose();
              }}
            >
              {item.label}
            </button>
          ))}

        </div>
      </div>
    </div>
  );
};

export default PartnerSelectModal;